import { render, staticRenderFns } from "./SidebarSubHeadline.vue?vue&type=template&id=740cd557&scoped=true&"
import script from "./SidebarSubHeadline.vue?vue&type=script&lang=js&"
export * from "./SidebarSubHeadline.vue?vue&type=script&lang=js&"
import style0 from "./SidebarSubHeadline.vue?vue&type=style&index=0&id=740cd557&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740cd557",
  null
  
)

export default component.exports